import { Link, useNavigate } from "react-router-dom";
import "../../styles/components/ProfessionalPageNav.css";

const ProfessionalPageNav = () => {
  const navigate = useNavigate();

  return (
    <nav
      className="professional-page-nav"
      aria-label="Professional page navigation"
    >
      <button
        type="button"
        className="professional-nav-button"
        onClick={() => navigate(-1)}
      >
        ← Back
      </button>

      <Link
        to="/professional/dashboard"
        className="professional-nav-link"
      >
        Dashboard
      </Link>

      <Link
        to="/"
        className="professional-nav-link"
      >
        Home
      </Link>
    </nav>
  );
};

export default ProfessionalPageNav;